
export const jsonOrFail = async (rsp) => {
    if(rsp.status != 200) {
        throw {message: `bad response status ${rsp.status}: ${rsp.statusText}`, detail: rsp};
    }            

    try{
        return rsp.json();

    } catch(e) {
        throw {message:"bad json ${e}", detail: e}

    }
}
